import { render, staticRenderFns } from "./BtnReprovarConformidadeTecnica.vue?vue&type=template&id=ed83387e"
import script from "./BtnReprovarConformidadeTecnica.vue?vue&type=script&lang=js"
export * from "./BtnReprovarConformidadeTecnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports